import { render } from "./BaseCard.vue?vue&type=template&id=4b7aff4f&scoped=true"
const script = {}

import "./BaseCard.vue?vue&type=style&index=0&id=4b7aff4f&scoped=true&lang=css"

import exportComponent from "/Users/davidmarchesson2/Sites/app.idtonic.com/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b7aff4f"]])

export default __exports__